import React from "react"
import PageBuilderActions from "./actions/PageBuilderActions"
import clsx from "clsx"
import PageBuilderConstants from "./constants/PageBuilderConstants"


class DeviceToolbar extends React.Component {

  constructor(props) {
    super(props);
    this._onClick = this._onClick.bind(this);
  }

  /**
  * Builds class name string
  * @returns {String}
  */
  classSet(name) {
    var classes = {
          'btn btn-secondary btn-lg': true,
          'active': this.props.mode === name
        };

    return clsx(classes)
  }

  render() {
    var self = this;

    var toolbarClasses = clsx({
      "btn-toolbar": true,
      "disabled": this.props.activeRowId !== null || this.props.resizeRowId !== null
    });

    // var buttonClassSet = function (name) {

    // }

    var buttons = [PageBuilderConstants.COMPOSE, PageBuilderConstants.DESKTOP, PageBuilderConstants.TABLET, PageBuilderConstants.CELL].map(function (name) {
      return (
        <button onClick={self._onClick.bind(null, name)} key={name} className={self.classSet(name)} type="button">
          <span className={'ss-' + name}></span>
        </button>
      );
    });

    return (
      <div className={toolbarClasses}>
        <div className="btn-group device-view" role="group">
          {buttons}
        </div>
      </div>
    );
  }

  _onClick(name, event) {
    event.preventDefault();

    PageBuilderActions.changeMode(name);
  }

};

export default DeviceToolbar
